/**
 * App color tokens — backed by Spark CSS variables.
 *
 * These are valid CSS values that work in both inline styles and CSS.
 * Prefer using Spark component props (e.g. Text color="primary") or
 * CSS classes over referencing this file directly.
 */
export const colors = {
    green: 'var(--semantic-feedback-success-on-surface)',
    purple: 'var(--primitive-alternative-bold-03)',
    fineTuning: 'var(--primitive-alternative-bold-03)',
    domainAdaptation: 'var(--primitive-alternative-bold-05)',
    orange: 'var(--semantic-feedback-warning-on-surface)',
    amber: 'var(--semantic-feedback-warning-on-surface-elevated)',
    red: 'var(--semantic-feedback-critical-on-surface)',
    light_blue: 'var(--primitive-blue-400)',
    optimizing: 'var(--semantic-graph-series-03)',
    gray: 'var(--semantic-content-tertiary)',
    buttonsBlue: 'var(--semantic-action-primary-bg-default)',
    cyan: 'var(--primitive-alternative-bold-05)',
    lightGreen: 'var(--primitive-green-400)',
    yellow: 'var(--semantic-feedback-warning-on-surface-elevated)',
    pink: 'var(--semantic-graph-series-03)',
    darkBlue: 'var(--primitive-deep-blue-700)',
    tagColors: [
        'var(--semantic-graph-series-01)',
        'var(--semantic-graph-series-09)',
        'var(--semantic-graph-series-08)',
        'var(--semantic-graph-series-06)',
        'var(--semantic-graph-series-05)',
        'var(--semantic-graph-series-02)',
        'var(--semantic-graph-series-04)',
        'var(--semantic-graph-series-03)',
    ],
};
